import { PICS_URL } from 'api';
import AddOrLinkButton from 'components/AddOrLinkButton';
import InputSelect from 'components/InputSelect';
import Counter2 from 'components/counter2';
import CalculatorPackichQuote from 'components/quote/packich_quote';
import { ROUTES_PATHS } from 'const';
import { useStores } from 'hooks/useStores';
import { format_price } from 'js/utils';
import React, { useEffect, useRef, useState } from "react";
import Price from './components/Price';

const GlueTapeLogo = () => {
  const [count, setCount] = useState(1);
  const [countPacks, setCountPacks] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFetchedAdd, setIsFetchedAdd] = useState(false);
  const [items, setItems] = useState({});
  const [minCount, setMinCount] = useState(1);
  const [fetch, setFetch] = useState(1);
  const [bgColor, setBgColor] = useState(1);
  const [defaultBgColor, setDefaultBgColor] = useState(1);
  const [colors, setColors] = useState(1);
  const [defaultColors, setDefaultColors] = useState(1);
  const [width, setWidth] = useState(1);
  const [defaultWidth, setDefaultWidth] = useState(1);
  const [length, setLength] = useState(1);
  const [defaultLength, setDefaultLength] = useState(1);
  const [isAdd, setIsAdd] = useState(false);

  const { api } = useStores();

  useEffect(() => {
    setIsLoaded(false);
    api.catalog
      .getGlueTapeLogoCalc({
        bg_color: bgColor,
        colors: colors,
        width: width,
        length: length,
        count: count,
      })
      .then((response) => {
        setItems(response);
        const minPackCount = response.min_pack_count;
        setMinCount(
          minPackCount > 1
            ? minPackCount * response.in_pack_count
            : response.multiplicity
        );

        for (let item of response.colors) {
          if (item.is_active === true) {
            setDefaultColors(item);
          }
        }
        for (let item of response.width) {
          if (item.is_active === true) {
            setDefaultWidth(item);
          }
        }
        for (let item of response.length) {
          if (item.is_active === true) {
            setDefaultLength(item);
          }
        }
        for (let item of response.bg_color) {
          if (item.is_active === true) {
            setDefaultBgColor(item);
          }
        }
        setIsLoaded(true);
      });
  }, [fetch]);

  const lightFetchRef = useRef(true);
  const lightFetch = function () {
    // If the main request is not completed yet or is initial setup of
    // `count` property then we dont send this request.
    if (!isLoaded) {
      return;
    }
    if (lightFetchRef.current) {
      lightFetchRef.current = false;
      return;
    }

    api.catalog
      .getGlueTapeLogoCalc({
        bg_color: bgColor,
        colors: colors,
        width: width,
        length: length,
        count: count,
      })
      .then((response) => {
        setItems(response);
      });
  };

  const bgColorHandler = (value) => {
    setBgColor(value.value);
    setCount(minCount);
    setCountPacks(1);
    setFetch(fetch + 1);
    restartButton();
  };

  const colorsHandler = (value) => {
    setColors(value.value);
    setCount(minCount);
    setCountPacks(1);
    setFetch(fetch + 1);
    restartButton();
  };

  const widthHandler = (value) => {
    setWidth(value.value);
    setCount(minCount);
    setCountPacks(1);
    setFetch(fetch + 1);
    restartButton();
  };

  const lengthHandler = (value) => {
    setLength(value.value);
    setCount(minCount);
    setCountPacks(1);
    setFetch(fetch + 1);
    restartButton();
  };

  const resetHandler = () => {
    setCount(minCount);
    setCountPacks(1);
    setBgColor(1);
    setColors(1);
    setWidth(1);
    setLength(1);
    setFetch(fetch + 1);
    setIsAdd(false);
  };

  const restartButton = () => {
    setIsAdd(false);
  };

  useEffect(() => {
    if (isLoaded) {
      setCount(minCount);
    }
  }, [isLoaded]);

  const [isLoadedCounters, setIsLoadedCounters] = useState(false);
  const [restartCounters, setRestartCounters] = useState(1);

  useEffect(() => {
    setIsLoadedCounters(true);
  }, [restartCounters]);

  const handleCountChange = function () {
    if (count === 0) {
      setCount(minCount);
      return;
    }
    if (count / items.in_pack_count === countPacks) {
      lightFetch();
      return;
    }
    if (count < items.in_pack_count * items.min_pack_count) {
      setCount(minCount);
      return;
    }
    const newCount = Math.ceil(count / items.in_pack_count);
    if (newCount === countPacks) {
      setCount(
        items.min_pack_count > 1
          ? countPacks * items.in_pack_count
          : countPacks * items.multiplicity
      );
    } else {
      setCountPacks(newCount);
    }
    setIsLoadedCounters(false);
    setRestartCounters(restartCounters + 1);
    lightFetch();
  };

  const countRef = useRef(true);
  useEffect(() => {
    if (countRef.current) {
      // do componentDidMount logic
      countRef.current = false;
    } else {
      // do componentDidUpdate logic
      handleCountChange();
    }
  }, [count]);

  const countPackRef = useRef(true);
  useEffect(() => {
    if (countPackRef.current) {
      // do componentDidMount logic
      countPackRef.current = false;
    } else {
      // do componentDidUpdate logic
      if (countPacks < items.min_pack_count) {
        setCountPacks(items.min_pack_count);
        return;
      }
      setCount(
        items.min_pack_count > 1
          ? countPacks * items.in_pack_count
          : countPacks * items.multiplicity
      );
      setIsLoadedCounters(false);
      setRestartCounters(restartCounters + 1);
    }
  }, [countPacks]);

  const postItem = () => {
    setIsFetchedAdd(true);

    api.cart
      .postCartItem({
        product_article: items.article,
        item_quantity: count,
        package_quantity: countPacks,
      })
      .then(() => changeBasketCount())
      .finally(() => {
        setIsFetchedAdd(false);
        setIsAdd(true);
      });
  };

  const changeBasketCount = () => {
    api.cart
      .getCartItems()
      .then((response) => {
        let counters = document.querySelectorAll(".basket-counter");
        for (let counter of counters) {
          counter.innerText = String(response.length);
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
        }
      });
  };

  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  useEffect(() => {
    if (isLoaded) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoaded]);

  let slideIndex = 1;
  function showSlides(slideIndex) {
    let sliderSize = document.querySelector(".how-gallery-slider").clientWidth;
    const slides = document.querySelectorAll(
      ".how-gallery-slider__slides-item"
    );
    for (let slide of slides) {
      slide.style.transform = `translateX(-${(slideIndex - 1) * sliderSize}px)`;
    }

    const dots = document.querySelectorAll(".controls-dots-dot");
    for (let dot of dots) {
      dot.classList.remove("controls-dots-dot-active");
    }
    dots[slideIndex - 1].classList.add("controls-dots-dot-active");
  }

  useEffect(() => {
      if (document.querySelectorAll(".controls-dots-dot").length !== 0) {
        const dots = document.querySelectorAll(".controls-dots-dot");
        if (dots.length === 1) {
          document.querySelector(
            ".how-gallery-slider__controls"
          ).style.display = "none";
        }
        dots[0].classList.add("controls-dots-dot-active");
        for (let i = 0; i < dots.length; i++) {
          const dot = dots[i];
          dot.addEventListener("click", () => {
            slideIndex = i + 1;
            showSlides(slideIndex);
          });
        }
        let backBtn = document.querySelector("#backBtn");
        backBtn.addEventListener("click", back);
        let frvBtn = document.querySelector("#frvBtn");
        frvBtn.addEventListener("click", frv);
      }
  }, []);

  const back = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === 1) {
        slideIndex = dots.length;
      } else {
        slideIndex -= 1;
      }
      showSlides(slideIndex);
  };

  const frv = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === dots.length) {
        slideIndex = 1;
      } else {
        slideIndex += 1;
      }
      showSlides(slideIndex);
  };

  return (
    <div className='calculator-main-content-calc'>
      <div className='calc-setings'>
        <div className='calc-settings-wrap'>
          <ul className='calc-settings__list'>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Фон:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded ? (
                  <InputSelect
                    defaultValue={defaultBgColor}
                    options={items.bg_color}
                    onchangeInput={bgColorHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>
                Нанесение:
                {isLoaded ? (
                  <span className='tooltip'>
                    <span className='tooltiptext tooltiptext-colors'>
                      {items.page_data.name_hint !== ""
                        ? items.page_data.name_hint
                        : "Минимальная партия: \n1 цвет нанесения – 3 коробки \n2 цвета нанесения – 5 коробок \n3 цвета нанесения – 10 коробок"}
                    </span>
                  </span>
                ) : null}
              </p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded ? (
                  <InputSelect
                    defaultValue={defaultColors}
                    options={items.colors}
                    onchangeInput={colorsHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Ширина, мм:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded ? (
                  <InputSelect
                    defaultValue={defaultWidth}
                    options={items.width}
                    onchangeInput={widthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Длина, м:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded ? (
                  <InputSelect
                    defaultValue={defaultLength}
                    options={items.length}
                    onchangeInput={lengthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            {!isLoaded || items.in_pack_count === 1 ? null : (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.package_count_text !== ""
                    ? items.page_data.package_count_text
                    : "Количество, коробок:"}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter1"}
                    onChange={setCountPacks}
                    count={countPacks}
                    multiplicity={items.multiplicity}
                    packages={true}
                    minCount={items.min_pack_count}
                    step={1}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            )}
            {!isLoaded ? null : (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.count_text !== ""
                    ? items.page_data.count_text
                    : "Количество, шт:"}
                  {items.in_pack_count === 1 ? null : (
                    <span className='tooltip'>
                      <span className='tooltiptext'>
                        {items.page_data.package_count_hint !== ""
                          ? items.page_data.package_count_hint
                          : `1 коробка = ${items.in_pack_count} штук(и)`}
                      </span>
                    </span>
                  )}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter2"}
                    onChange={setCount}
                    count={count}
                    minCount={minCount}
                    step={items.multiplicity}
                    multiplicity={items.multiplicity}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            )}
            <li className='calc-settings__list-item mobile-list-item'>
              <p className='calc-settings__list-item-title'>Наличие:</p>
              {items.in_stock == "в наличии" ||
              items.in_stock == "В наличии" ? (
                <div className='calc-settings__list-item-setting settings-stock'>
                  {items.in_stock}
                </div>
              ) : (
                <div className='calc-settings__list-item-setting settings-outOfStock'>
                  {items.in_stock}
                </div>
              )}
            </li>
            <Price minPrice={minPrice} maxPrice={maxPrice} />

            <li className='calc-settings__list-item calc-border'>
              <div className='calc-settings-border'></div>
            </li>
            <li className='calc-settings__list-item  calc-cart'>
              <button
                className='calc-settings__button-reset'
                onClick={resetHandler}
              >
                <div className='button-reset-icon'></div>
                <div className='button-reset-title'>Сбросить</div>
              </button>
              <AddOrLinkButton
                isAdd={isAdd}
                postItem={postItem}
                isFetchedAdd={isFetchedAdd}
              />
            </li>
          </ul>
        </div>
      </div>
      <div className='calc-right'>
        <div className='calc-right__content'>
          {items.image ? (
            <div className='calc-right__img'>
              <img loading="lazy" src={PICS_URL + items.image} alt={items.title || ''} />
            </div>
          ) : null}
          <h3 className='calc-right__title'>Клейкие ленты с логотипом</h3>
          <table className='calc-right__table'>
            <tbody>
              <tr>
                <th>Артикул</th>
                <td>{items.article}</td>
              </tr>
              <tr>
                <th>Техническое название</th>
                <td>{items.title}</td>
              </tr>
              <tr>
                <th>Стоимость клише, ₽</th>
                <td>{items.cliche_cost}</td>
              </tr>
            </tbody>
          </table>
          {items?.page_data?.pak_pakych_quote ? (
            <CalculatorPackichQuote
              text={items.page_data.pak_pakych_quote.text}
              bgColor={items.page_data.pak_pakych_quote.bg_color}
              borderColor={items.page_data.pak_pakych_quote.border_color}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default GlueTapeLogo;
